const XIcon = ({color = 'black', width = 16, height = 16}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.46324 2.25105C3.1285 1.91632 2.58579 1.91632 2.25105 2.25105C1.91632 2.58579 1.91632 3.1285 2.25105 3.46324L6.78783 8.00001L2.25105 12.5368C1.91632 12.8715 1.91632 13.4142 2.25105 13.749C2.58579 14.0837 3.1285 14.0837 3.46324 13.749L8.00001 9.21219L12.5368 13.749C12.8715 14.0837 13.4142 14.0837 13.749 13.749C14.0837 13.4142 14.0837 12.8715 13.749 12.5368L9.21219 8.00001L13.749 3.46324C14.0837 3.1285 14.0837 2.58579 13.749 2.25105C13.4142 1.91632 12.8715 1.91632 12.5368 2.25105L8.00001 6.78783L3.46324 2.25105Z"
            fill={color}
        />
    </svg>
);

export default XIcon;
